var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-div',{staticClass:"pa-0 ma-0 fill-height",staticStyle:{"background-color":"#f5f5f5"},attrs:{"fluid":""}},[_c('div',[_c('v-card',{staticClass:"mx-auto",attrs:{"flat":"","tile":""}},[_c('story',{attrs:{"changed":_vm.changed,"data":_vm.selectedStory}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }